import { render, staticRenderFns } from "./PointOfSales.vue?vue&type=template&id=9ee0ce9a&"
import script from "./PointOfSales.vue?vue&type=script&lang=js&"
export * from "./PointOfSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports